import React from "react";
import { Check, Sparkles } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function SolutionList({ content }) {
  const { t } = useLanguage();
  const items = Array.from({ length: 6 })
    .map((_, i) => content?.[`solution_${i + 1}`])
    .filter(Boolean);

  return (
    <section data-testid="solutions-section" className="bg-cream py-section sm:py-section-lg border-t border-mist">
      <div className="container-page grid gap-12 lg:grid-cols-12 lg:gap-16">
        <Reveal as="div" className="lg:col-span-5">
          <span className="eyebrow"><Sparkles className="h-3 w-3 text-gold" />{content?.solutions_eyebrow || t("service.solutions_eyebrow")}</span>
          <h2 className="mt-5 font-display text-display-2 font-semibold text-ink">
            {content?.solutions_title || t("service.solutions_title")}
          </h2>
          <p className="mt-5 text-body-lg text-ink/65 leading-relaxed max-w-md">
            {content?.solutions_subtitle}
          </p>
          <div className="hairline-gold mt-8" />
        </Reveal>

        <ul className="lg:col-span-7 space-y-3" data-testid="solutions-list">
          {items.map((it, i) => (
            <Reveal as="li" key={i} delay={i * 0.05}
              className="flex items-start gap-4 rounded-xl bg-white border border-mist p-5 hover:border-gold/40 transition-colors duration-500"
              data-testid={`solution-item-${i + 1}`}
            >
              <span className="flex-shrink-0 mt-0.5 inline-flex h-7 w-7 items-center justify-center rounded-full bg-gold/15 text-gold">
                <Check className="h-3.5 w-3.5" strokeWidth={2.5} />
              </span>
              <p className="text-body text-ink/85 leading-relaxed">{it}</p>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
